import sales from './sales';
import debts from './debts';
import invoice from './invoice';

export default {
  namespaced: true,
  modules: {
    sales,
    debts,
    invoice,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report/index.js